import { render, staticRenderFns } from "./editable-label.vue?vue&type=template&id=93e1b1dc&"
import script from "./editable-label.vue?vue&type=script&lang=ts&"
export * from "./editable-label.vue?vue&type=script&lang=ts&"
import style0 from "./editable-label.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports